import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiClient from "src/config/ApiClient";
import { profileImageSource } from "src/config/profileImage";
import { toast } from "react-toastify";

// Async thunk to fetch profile data
export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (customerId, { rejectWithValue }) => {
    try {
    
      const profileResponse = await ApiClient.get(`/customer/${customerId}`);
      // console.log("profile",profileResponse.data.data);
      localStorage.setItem("CustomerName",profileResponse.data.data.customer_name);
      // console.log("customerName",profileResponse.data.data.customer_name);
      return profileResponse.data.data;
     
    } catch (error) {
      return rejectWithValue(error.response?.data || { msg: "Unable to reach the server. Please try again." });
    }
  }
);

// Async thunk to update profile picture
export const updateProfilePicture = createAsyncThunk(
  "profile/updateProfilePicture",
  async ({ customerId, file }, { rejectWithValue, dispatch }) => {
    try {
      if (!file || !['image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(file.type)) {
        return rejectWithValue({ msg: "Choose a JPEG, PNG, WebP, or GIF image." });
      }
      if (file.size > 5 * 1024 * 1024) return rejectWithValue({ msg: "Choose an image smaller than 5 MB." });
      const formData = new FormData();
      formData.append("customer_profile", file);

      // Update the profile picture
      const response = await ApiClient.patch(`/customer/${customerId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // Return the updated data from the PATCH response
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { msg: "Unable to reach the server. Please try again." });
    }
  }
);
const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profileData: null,
    profilePicture: "",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch Profile
      .addCase(fetchProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = action.payload;
        state.profilePicture = profileImageSource(action.payload?.customer_profile, action.payload?.mimeType);

      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

       .addCase(updateProfilePicture.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateProfilePicture.fulfilled, (state, action) => {
      state.loading = false;
      state.profileData = action.payload; // Update the entire profile data
      
      state.profilePicture = profileImageSource(action.payload?.customer_profile, action.payload?.mimeType);

      toast.success("Profile picture updated successfully!");
    })
    .addCase(updateProfilePicture.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
      toast.error(action.payload?.msg || action.payload?.message || "Failed to update profile picture");
    });
  },
});

export default profileSlice.reducer;